import { detailedDiff, diff } from 'deep-object-diff';
import { flatten } from 'flat';
// add more chars here
const blacklistedChars = ['<', '>'];
const diffObjs = (o1, o2, detailed = false) => detailed ? detailedDiff(o1, o2) : diff(o1, o2);
export const objectUtils = {
    diffObjs,
};
export function isClean(obj) {
    const flattenedObj = flatten(obj);
    const keys = Object.keys(flattenedObj);
    for (let index = 0; index < keys.length; index++) {
        const str = flattenedObj[keys[index]];
        if (typeof str === 'string' && !isStringClean(str)) {
            return keys[index];
        }
    }
    return undefined;
}
export function sanitizeString(str) {
    // eslint-disable-next-line no-useless-escape
    return str.replace(/[^a-z0-9áéíóúñäüßö*+&% .,_-]/gim, '').trim();
}
export function isStringClean(str) {
    for (let i = 0; i < blacklistedChars.length; i += 1) {
        if (str.indexOf(blacklistedChars[i]) !== -1) {
            return false;
        }
    }
    return true;
}
/**
 * Removes undefined properties from an object.
 */
export function removeUndefinedProps(obj) {
    if (!obj)
        return obj;
    return JSON.parse(JSON.stringify(obj));
}
